var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7859_58042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 8.33268V3.33268C17.4999 2.41602 16.7499 1.66602 15.8333 1.66602H2.49992C1.58325 1.66602 0.841585 2.41602 0.841585 3.33268L0.833252 13.3327C0.833252 14.2493 1.58325 14.9993 2.49992 14.9993H11.6666V10.8327C11.6666 9.44935 12.7833 8.33268 14.1666 8.33268H17.4999ZM9.16659 9.16602L2.49992 4.99935V3.33268L9.16659 7.49935L15.8333 3.33268V4.99935L9.16659 9.16602Z",
    fill: "#193051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.666V14.9993C17.5 15.916 16.75 16.666 15.8333 16.666C14.9167 16.666 14.1667 15.916 14.1667 14.9993V11.2493C14.1667 11.016 14.35 10.8327 14.5833 10.8327C14.8167 10.8327 15 11.016 15 11.2493V14.9993H16.6667V11.2493C16.6667 10.0993 15.7333 9.16602 14.5833 9.16602C13.4333 9.16602 12.5 10.0993 12.5 11.2493V14.9993C12.5 16.841 13.9917 18.3327 15.8333 18.3327C17.675 18.3327 19.1667 16.841 19.1667 14.9993V11.666H17.5Z",
    fill: "#193051"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7859_58042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachEmail);
export default __webpack_public_path__ + "static/media/attach_email.71b36222018757edcf1c2bc4721e4bee.svg";
export { ForwardRef as ReactComponent };